import { render, staticRenderFns } from "./form_responses.vue?vue&type=template&id=123993b0&scoped=true"
import script from "./form_responses.vue?vue&type=script&lang=js"
export * from "./form_responses.vue?vue&type=script&lang=js"
import style0 from "./form_responses.vue?vue&type=style&index=0&id=123993b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123993b0",
  null
  
)

export default component.exports